// assets/brand-carousel.js
(function () {
  function initCarousel(root) {
    const viewport = root.querySelector('.brand-viewport');
    const track = root.querySelector('.brand-track');
    const prev = root.querySelector('.brand-nav.prev');
    const next = root.querySelector('.brand-nav.next');

    if (!viewport || !track || !prev || !next) return;

    // Clone slides for infinite loop
    if (!track.dataset.cloned) {
      track.dataset.cloned = '1';
      track.innerHTML = track.innerHTML + track.innerHTML;
    }

    const slide = track.querySelector('.brand-slide');
    const slideWidth = slide.offsetWidth;
    const gap = parseFloat(getComputedStyle(track).gap) || 0;
    const step = (slideWidth + gap) * 3;

    // Start at first real section
    viewport.scrollLeft = track.scrollWidth / 4;

    function wrap() {
      const half = track.scrollWidth / 2;
      if (viewport.scrollLeft <= 0) {
        viewport.scrollLeft += half;
      } else if (viewport.scrollLeft >= half * 1.5) {
        viewport.scrollLeft -= half;
      }
    }

    viewport.addEventListener('scroll', wrap);

    prev.addEventListener('click', () => {
      viewport.scrollBy({ left: -step, behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      viewport.scrollBy({ left: step, behavior: 'smooth' });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.brand-carousel').forEach(initCarousel);
  });
})();
